var __jsx = React.createElement;
import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
import { useIsAncestorOfFocusElement } from '@pelotoncycle/waffles';
import React from 'react';
import { activeClass, focusClass } from '@webtv/global-styles';
import { useCarouselFocusHandler } from './useCarouselFocusHandler';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var OptionHeightDP = 48;
var OptionWidthDP = 88;
export var CarouselSelect = function CarouselSelect(_ref) {
  var _options$selectedInde;

  var options = _ref.options,
      defaultIndex = _ref.defaultIndex,
      placeholderText = _ref.placeholderText,
      selectedIndex = _ref.selectedIndex,
      setSelectedIndex = _ref.setSelectedIndex,
      focusRef = _ref.focusRef,
      dataTestId = _ref.dataTestId;
  var isFocused = useIsAncestorOfFocusElement();

  var _useCarouselFocusHand = useCarouselFocusHandler(options.length, defaultIndex, selectedIndex, setSelectedIndex),
      isActive = _useCarouselFocusHand.isActive,
      nextIndex = _useCarouselFocusHand.nextIndex,
      prevIndex = _useCarouselFocusHand.prevIndex;

  return /*#__PURE__*/_jsxs(Container, {
    children: [/*#__PURE__*/_jsx(Select, {
      value: selectedIndex !== null && selectedIndex !== void 0 ? selectedIndex : '',
      onChange: function onChange(v) {
        return null;
      }
    }), /*#__PURE__*/_jsx(NextOrPrevOption, {
      className: cx(isActive && activeClass),
      children: options[prevIndex].displayName
    }), /*#__PURE__*/_jsx(CurrentOption, {
      "data-test-id": dataTestId,
      ref: focusRef,
      className: cx(isFocused && focusClass),
      children: selectedIndex !== null ? (_options$selectedInde = options[selectedIndex]) === null || _options$selectedInde === void 0 ? void 0 : _options$selectedInde.displayName : placeholderText
    }), /*#__PURE__*/_jsx(NextOrPrevOption, {
      className: cx(isActive && activeClass),
      children: options[nextIndex].displayName
    })]
  });
};
var Container = /*#__PURE__*/styled("div")({
  name: "Container",
  class: "c1fpn3pe"
});
var Select = /*#__PURE__*/styled("select")({
  name: "Select",
  class: "s7qhz68"
});
var Option = /*#__PURE__*/styled("div")({
  name: "Option",
  class: "ovai82f"
});
var CurrentOption = /*#__PURE__*/styled(Option)({
  name: "CurrentOption",
  class: "c1va2ry"
});
var NextOrPrevOption = /*#__PURE__*/styled(Option)({
  name: "NextOrPrevOption",
  class: "n1uipnfe"
});

require("../../../apps/tv/.linaria-cache/packages/@webtv/inputs/CarouselSelect.linaria.module.css");